<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
import { mapMutations, mapActmapActions } from "vuex";
import watermark from 'watermark-dom'

export default {
	name: 'app',
	created() {
		this.$store.dispatch("getUserInfo");
	},
	mounted() {
		// console.log("~~~~~~~~~~~1231232~~~~~~"+remove);
		// setTimeout(()=>{
		// 	let userToken = toolsUtils.getCookiesSync("user_token");
		// 	let user_info = null;
		// 	if(toolsUtils.getCookiesSync("user_info")){
		// 	    user_info = CryptoJS.AES.decrypt(toolsUtils.getCookiesSync("user_info"), 'jfgas12444#####').toString(CryptoJS.enc.Utf8); 
		// 	    user_info = JSON.parse(user_info);
		// 	}
		// 		console.log("~~~~~~~~~~~1231232~~~~~~"+user_info);
		// 			console.log(user_info);
		// 		console.log("~~~~~~~~"+userToken);
		// 	if(user_info&&!toolsUtils.isObjEmpty(userToken))
		// 	{
		// 		watermark.load({watermark_txt:user_info.userName+" "+user_info.loginName+" 测试环境"});
		// 	}else{
		// 		watermark.load({watermark_txt:"测试环境"});
		// 	}
		// },1000)
	}
}
</script>

<style lang="scss">
body {
	box-sizing: border-box;
	margin: 0;
	padding: 0;
	background: #E5F3F1;
}

.flex-row {
	display: flex;
	flex-direction: row;
}

.flex-column {
	display: flex;
	flex-direction: column;
}

.f-align-center {
	align-items: center;
}

.f-justify-center {
	justify-content: center;
}

.f-justify-end {
	justify-content: flex-end;
}

.f-center {
	justify-content: center;
	align-items: center;
}

.f-justify-between {
	justify-content: space-between;
}

.flex1 {
	flex: 1;
}

.flex-nowrap {
	flex-wrap: nowrap;
}

.flex-wrap {
	flex-wrap: wrap;
}
</style>
